import { authTheme } from "../../data/auth/authTheme";

export function AuthFormDivider({ label }) {
  return (
    <div className="relative my-8">
      <div className="absolute inset-0 flex items-center" aria-hidden>
        <div
          className="w-full border-t"
          style={{ borderColor: authTheme.inputBorder }}
        />
      </div>
      <p className="relative flex justify-center">
        <span
          className="bg-white px-4 text-[11px] font-semibold uppercase tracking-[1.4px]"
          style={{ color: "#9CA3AF" }}
        >
          {label}
        </span>
      </p>
    </div>
  );
}
